// apps/web/src/features/requests/dictionarySelections.queries.ts
//
// React Query hooks for the active Roads / Packaging dictionary catalogs
// (#996). Mirrors `useActiveArrivalCities` — one query per dictionary,
// single cache key so the editor multiselects and any future admin
// surface share one fetched list. Limit set to `500` (the same max as
// `arrival-cities`) to fit the whole catalog in one round trip.

import { useQuery } from '@tanstack/react-query';
import { listPackagingOptions } from '../../api/packaging-options.js';
import { listRoadOptions } from '../../api/road-options.js';

export interface DictionaryOption {
  id: string;
  name: string;
  active: boolean;
  sortOrder: number;
}

export const ROAD_OPTIONS_ACTIVE_QK = ['road-options-active'] as const;
export const PACKAGING_OPTIONS_ACTIVE_QK = ['packaging-options-active'] as const;

export function useActiveRoadOptions(options: { enabled?: boolean } = {}) {
  return useQuery<DictionaryOption[]>({
    queryKey: ROAD_OPTIONS_ACTIVE_QK,
    queryFn: async () => {
      const res = await listRoadOptions({ active: true, limit: 500 });
      return res.items.map((r) => ({
        id: r.id,
        name: r.name,
        active: r.active,
        sortOrder: r.sortOrder,
      }));
    },
    enabled: options.enabled ?? true,
  });
}

export function useActivePackagingOptions(options: { enabled?: boolean } = {}) {
  return useQuery<DictionaryOption[]>({
    queryKey: PACKAGING_OPTIONS_ACTIVE_QK,
    queryFn: async () => {
      const res = await listPackagingOptions({ active: true, limit: 500 });
      return res.items.map((p) => ({
        id: p.id,
        name: p.name,
        active: p.active,
        sortOrder: p.sortOrder,
      }));
    },
    enabled: options.enabled ?? true,
  });
}
